<template>
  <v-app>
    <Navbar v-if="loggedIn && !$route.meta.hideNavbar" v-bind:items="navBarItems"/>
    <v-main>
      <v-snackbar v-model="alertToggle" :content-class="alertClass" :timeout="readingTime(alertMessage)" rounded="pill">
        {{ alertMessage }}
      </v-snackbar>
      <div style="display: flex; flex-direction: column; height: 100%; padding-top: var(--safe-area-inset-top); padding-bottom: var(--safe-area-inset-bottom); padding-left: var(--safe-area-inset-left); padding-right: var(--safe-area-inset-right);">
        <div style="flex: 1 1 1;">
          <PatientProfile v-if="false" />
        </div>
        <div style="flex: 1 1 1; height: 100%">
          <router-view />
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import EventBus from "@/eventBus";
import dayjsMixin from "@/mixins/dayjsMixin";
import plivoMixin from "@/mixins/plivoMixin";
import Navbar from "@/components/Navbar";
import PatientProfile from "@/components/PatientProfile";
import { mapActions, mapMutations, mapGetters} from "vuex";


export default {
  name: "App",
  components: { Navbar, PatientProfile },
  mixins: [dayjsMixin, plivoMixin],
  data() {
    return {
      navBarItems: [
        //{title: "Client Onboarding", route: "/clientonboarding", icon: "mdi-account"},
        // {
        //   title: "Home",
        //   route: "/home",
        //   icon: "mdi-home",
        // },
        /*{
          title: "Service Integration",
          route: "/service",
          icon: "mdi-account-wrench-outline"
        },*/
        // {
        //   title: "Front Desk Workflow",
        //   route: "/frontdesk",
        //   icon: "mdi-monitor",
        // },
        // {
        //   title: "Outstanding Claims Workflow",
        //   route: "/osclaims",
        //   icon: "mdi-currency-usd",
        // },
        // {
        //   title: "General Conversation",
        //   route: "/conversation",
        //   icon: "mdi-chat",
        // },
        // {
        //   title: "Recall Workflow",
        //   route: "/recall",
        //   icon: "mdi-phone-forward",
        // },
        // {
        //   title: "VPI",
        //   route: "/vpi",
        //   icon: "mdi-view-dashboard",
        // },
        {
          title: "Patient Map",
          route: "/patientmap",
          icon: "mdi-map-marker",
        },
      ],
      alertToggle: false,
      alertMessage: "",
      alertClass: "info-snack"
    };
  },
  computed: {
   ...mapGetters(["loggedIn"])
  },
  methods:{
    ...mapActions("window", ["updateWindowWidth"]),
    ...mapMutations("window",["isIOS"])
  },
  created() {
    EventBus.$on("alert", (data) => {
      if (typeof data === 'object' && data.message && data.type) {
        // If 'data' is an object and has both 'message' and 'type' properties
        this.alertMessage = data.message;
        this.alertClass = data.type; // Assuming 'type' should map directly to a class
      } else {
        // If 'data' is just a string (support for legacy events)
        this.alertMessage = data;
        this.alertClass = "info-snack"; // Default class
      }
      console.log("Message sent to snackbar:", this.alertMessage, "Class:", this.alertClass);
      this.alertToggle = true;
    });
    EventBus.$on("toggleDarkMode", (dark_mode) => {
      this.$vuetify.theme.dark = dark_mode;
    });
  },
  mounted() {
    this.updateWindowWidth(); 
    window.addEventListener("resize", this.updateWindowWidth);
    const userAgent = navigator.userAgent || window.opera;
    let ios = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    this.isIOS(ios);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
};
</script>

<style>
/* global styles */
.v-application {
    color: #202020 !important;
}
.list {
  background: #ffffff;
}
.highlighted {
  background: #e4edf8;
}
.hovered {
  background: #f5f5f5;
}
.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.caption {
  font-size: 0.75rem;
  line-height: 1.25rem;
}

.displayCenter {
  display: flex;
  justify-content: center;
}

.alignCenter {
  align-items: center;
}

.column {
  display: flex;
  flex-direction: column;
}

.m10 {
  margin: 10px;
}
.info-snack {
  background-color: #2196F3 !important; /* Blue */
  color: white;
}
.success-snack {
  background-color: #4CAF50 !important; /* Green */
  color: white;
}
.warning-snack {
  background-color: #FFC107 !important; /* Amber */
  color: black;
}
.error-snack {
  background-color: #F44336 !important ; /* Red */
  color: white;
}
/* removes scroll-bar on side of application when it is not needed */
html {
  overflow-y: auto;
}
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  14% {
    transform: scale(1.3);
  }
  28% {
    transform: scale(1);
  }
  42% {
    transform: scale(1.3);
  }
  70% {
    transform: scale(1);
  }
}

.heartbeat {
  animation: heartbeat 1.5s infinite;
  transform-origin: center;
}
</style>
